<div id="decal-icon">
  <div [ngClass]="decalColor" [attr.aria-label]="decalDescription">{{decalCode}}</div>
</div>



